import { Theme } from '@material-ui/core';
import { ComponentType, LazyExoticComponent, ReactNode } from 'react';
import { Dispatch } from 'redux';
import { AdminAppRoute } from 'src/adminPanel/core/AdminAppRoute';
import { AppRoute } from 'src/core/AppRoute';
import { AccountPrivilege } from 'src/core/hooks/account';
import { ProductGroupSlug } from 'src/entities/product-group/ProductGroup';

export type RoutePath = AppRoute | AdminAppRoute | string;

export interface RouteRuntimeContext {
    isProduction: boolean;
    isDevelopment: boolean;
    isAdminContext: boolean;
    isLoggedIn: boolean;
    hasPrivilege: (privilege: AccountPrivilege | AccountPrivilege[]) => boolean;
}

export interface SiteInitContext {
    dispatch: Dispatch<any>;
    runtime: RouteRuntimeContext;
    enabledModules: Set<string>;
}

export interface RouteDescriptor {
    key: string;
    route: RoutePath;
    component: ComponentType<any> | LazyExoticComponent<ComponentType<any>>;
    exact?: boolean;
    condition?: (context: RouteRuntimeContext) => boolean;
}

export interface NavigationItem {
    id: string;
    label: string;
    route: RoutePath;
}

export interface NavigationSection {
    id: string;
    label: string;
    items: NavigationItem[];
}

export interface SiteShellProps {
    site: SiteDefinition;
    children: ReactNode;
}

export interface SiteDefinition {
    id: string;
    label: string;
    description?: string;
    hostnames?: string[];
    routes: RouteDescriptor[];
    baseUrl?: string;
    productGroupSlugs?: readonly ProductGroupSlug[];
    navigation?: NavigationSection[];
    shell?: ComponentType<SiteShellProps>;
    theme?: (theme: Theme) => Theme;
    init?: (context: SiteInitContext) => void;
    adminServiceEnabled?: boolean;
    registerEnabled?: boolean;
}

export const resolveRoutePath = (route: RoutePath): string => (typeof route === 'string' ? route : route.path);
